import React from "react";
import { statusMeta, hexA, AUDIENCE_LABELS, LINK_LABELS, catLabel } from "./docConstants";
import { Lock } from "lucide-react";

export const StatusBadge = ({ status, testid }) => {
  const m = statusMeta(status);
  return (
    <span data-testid={testid}
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap"
      style={{ backgroundColor: hexA(m.hex, 0.14), color: m.hex }}>
      {m.label}
    </span>
  );
};

export const CategoryChip = ({ category }) => (
  <span className="inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium bg-[#F0F4F8] text-[#1C4358]">
    {catLabel(category)}
  </span>
);

export const VisibilityChips = ({ visibility, internalOnly }) => {
  if (internalOnly || !(visibility || []).length) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-medium text-[#6B7280]">
        <Lock size={11} /> Internal only
      </span>
    );
  }
  return (
    <span className="flex flex-wrap gap-1">
      {visibility.map((v) => (
        <span key={v} className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium bg-[#E8F0F4] text-[#1C4358]">
          {AUDIENCE_LABELS[v] || v}
        </span>
      ))}
    </span>
  );
};

export const LinkChips = ({ links = {}, labels = {} }) => {
  const keys = Object.keys(LINK_LABELS).filter((k) => {
    const idKey = k === "client" ? "client_user_id" : k === "external_account" ? "external_account_id" : `${k}_id`;
    return links[idKey];
  });
  if (!keys.length) return <span className="text-[11px] text-[#94A3B8]">—</span>;
  return (
    <span className="flex flex-wrap gap-1">
      {keys.map((k) => (
        <span key={k} className="inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-medium bg-[#F4F8FB] text-[#4B5563] border border-[#E6EDF2]">
          {LINK_LABELS[k]}{labels[k] ? `: ${String(labels[k]).slice(0, 24)}` : ""}
        </span>
      ))}
    </span>
  );
};
